import Service from "../../apiService";
import { toast } from "view/component/Alert";

const puskesmas = JSON.parse(localStorage.getItem("puskesmasProfile"));

export const searchVisitLaporan = async (params) => {
  try {
    const response = await Service.post("/report/kunjungan_pasien", params);
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchVisitReportGroup = async (params) => {
  try {
    const response = await Service.post(
      "/management/report_group_penyakit/report",
      params
    );
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchVisitLaporanByname = async (params) => {
  try {
    const response = await Service.post(
      "/report/kunjungan_pasien_by_name",
      params
    );
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchVisitLaporanByIcd = async (params) => {
  try {
    const response = await Service.post(
      "/report/kunjungan_pasien_by_diag",
      params
    );
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchVisitLaporanNoVisit = async (params) => {
  console.log(params, "no visit");
  try {
    const response = await Service.post(
      "/report/kunjungan_pasien_not_visit",
      params
    );
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchVisitLaporanProhits = async (params) => {
  try {
    const response = await Service.post("ht/get_by_name", params);
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchVisitOverdue = async (params) => {
  try {
    const response = await Service.post("report/overdue", {
      ...params,
      include: ['prescriptions.details.medicine']
    });
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchIlpReport = async (params) => {
  try {
    const response = await Service.post(
      "ilp/get_report_screening_name_list",
      params
    );
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchIlpReportCount = async (params) => {
  try {
    const response = await Service.post(
      "ilp/get_report_screening_count",
      params
    );
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchSensusLaporan = async (params) => {
  try {
    const response = await Service.post("/report/visit_sensus", params);
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchSepuluhBesar = async (params) => {
  try {
    const response = await Service.post("/report/sepuluh_besar", params);
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.data?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchLB1 = async (params) => {
  try {
    const response = await Service.post("/report/lb1_puskesmas", params);
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchLab = async (params) => {
  try {
    const response = await Service.post("/report/visit_lab", params);
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchLabCount = async (params) => {
  try {
    const response = await Service.post("/report/summary_visit_lab", params);
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchLabCountV2 = async (params) => {
  try {
    const response = await Service.post("/report/summary_visit_lab/v2", params);
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchLaporanTindakan = async (params) => {
  try {
    const response = await Service.post("/report/clinic_treatment", params);
    if (response) {
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchLaporanLB4 = async (params) => {
  try {
    const response = await Service.post("/report/lb4_puskesmas", params);
    if (response) {
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchLaporanLB4Header = async (params) => {
  try {
    const response = await Service.post("/report/lb4_puskesmas/header", params);
    if (response) {
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchLaporanKasir = async (params) => {
  try {
    const response = await Service.post("/report/cashier", params);
    if (response) {
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const getClinics = async () => {
  try {
    const responses = await Service.get(
      `/apm/clinics/read/${puskesmas.code}/2/0`
    );
    if (await responses) {
      let newArray = [];
      responses.data
        .filter((response) => response.active)
        .forEach((response) => {
          if (response.clinic.child.length)
            response.clinic.child.forEach((child) => {
              newArray.push({ value: child.clinic_id, label: child.name });
            });
          else {
            newArray.push({
              value: response.clinic.id,
              label: response.clinic.name,
            });
          }
        });
      return newArray;
    }
  } catch (error) {
    return [];
  }
};
export const getScreeningIlp = async () => {
  try {
    const responses = await Service.get(`/ilp/list_screening`);
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.screening_name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getICDGroups = async () => {
  try {
    const responses = await Service.get("/management/icd_group/read");
    if (responses) {
      return responses.data.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getAccidents = async () => {
  try {
    const responses = await Service.get("/management/accidents/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getPaymentTypes = async () => {
  try {
    const responses = await Service.get("/management/payment_types/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getWorkAreas = async () => {
  try {
    const responses = await Service.get("/management/work_areas/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.village_id, label: response.village.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const fetchSexs = async () => {
  try {
    const responses = await Service.get("/management/sex/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const fetchFlags = async () => {
  try {
    const responses = await Service.get("/management/flags/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const fetchWrd = async () => {
  try {
    const responses = await Service.get(
      "/management/work_related_disease/read"
    );
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getICD = async (inputValue) => {
  if (inputValue.length >= 3) {
    try {
      const responses = await Service.get(
        "management/icd10/read?keyword=" + inputValue
      );
      if (responses) {
        return responses.data.data.map((data) => {
          return {
            value: data.code,
            label: `${data.code} - ${data.name}`,
          };
        });
      }
    } catch (error) {
      return [];
    }
  }
};
export const getICDx = async (inputValue) => {
  if (inputValue.length >= 3) {
    try {
      const responses = await Service.get(
        "management/icd10/read?keyword=" + inputValue
      );
      if (responses) {
        return responses.data.data.map((data) => {
          return {
            value: data.code,
            label: `${data.code} - ${data.name}`,
          };
        });
      }
    } catch (error) {
      return [];
    }
  }
};

export const searchSanitasiLaporan = async (params) => {
  try {
    const response = await Service.post(
      "/registration/kesling/read?group=sanitasi",
      params
    );
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response.data;
    }
  } catch (error) {
    return [];
  }
};

export const searchKesehatanLingkunganLaporan = async (params) => {
  try {
    const response = await Service.post(
      "/registration/kesling/read?group=kesling",
      params
    );
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
      }
      return response.data;
    }
  } catch (error) {
    return [];
  }
};
